// extracted by mini-css-extract-plugin
export default {"link":"header_link__aG6jQ","text":"header_text__cyB2f"};